import { Card, CardContent} from "@/components/ui/card";
import React from "react";

interface EventCountCardProps {
  title: string;
  count: number;
  colour: string;
  bgcolour: string;
  icon: React.ElementType
}

export function EventCountCard({ title, count, colour, bgcolour, icon: Icon }: EventCountCardProps) {
  return (
    <Card>
      <CardContent className="p-4">
        <div className="flex items-center gap-3">
          <div className={`p-2 ${bgcolour} rounded-lg`}>
            < Icon className={`h-5 w-5 ${colour}`}/>
          </div>
          <div>
            <p className="text-sm text-bold-foreground">{title}</p>
            <p className="text-2xl font-bold">{count}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
